import PropTypes from 'prop-types';
import { MenuItem, TextField } from '@mui/material';

// Local per-tab treatment filter. value === 'all' means no treatment filter.
// Holds no global state — each tab owns its own selection.
export default function TreatmentFilterSelect({ treatments = [], value, onChange, label = 'Treatment' }) {
    return (
        <TextField
            select
            size="small"
            label={label}
            value={value ?? 'all'}
            onChange={(e) => onChange(e.target.value)}
            sx={{ minWidth: 200 }}
        >
            <MenuItem value="all">All treatments</MenuItem>
            {(Array.isArray(treatments) ? treatments : []).map((t) => (
                <MenuItem key={t.id} value={t.id}>
                    {t.treatment}{t.price ? ` · £${t.price}` : ''}
                </MenuItem>
            ))}
        </TextField>
    );
}

TreatmentFilterSelect.propTypes = {
    treatments: PropTypes.array,
    value: PropTypes.any,
    onChange: PropTypes.func,
    label: PropTypes.string,
};
